import { getAdMarkets } from '@/api/common';
import { queryCampaigns, queryGroups } from '@/api/ad';


export const verifyList = {
  // 正整数校验
  integer: {
    validator: (rule, value, callback) => {
      if (!/^(?:[1-9]\d*)$/.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    },
    trigger: 'change',
  },
  // 两位小数
  correctTwo: {
    validator: (rule, value, callback) => {
      if (!/^([1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/.test(value)) {
        callback(new Error("请输入大于0的两位小数"));
      } else {
        callback();
      }
    },
    trigger: "change",
  },
  // 执行频率校验
  frequencyc: {
    validator: (rule, value, callback) => {
      if (!/^(?:[1-9]\d*)$/.test(value) || value > 60) {
        callback(new Error("请输入1-60的正整数"));
      } else {
        callback();
      }
    },
    trigger: "blur",
  },
  // 只能输入数字
  number: {
    validator: (rule, value, callback) => {
      if (/[^\d.]/g.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    },
    trigger: "change",
  },
}
export const verifyCondition = {
  impressions: verifyList.integer,
  clicks: verifyList.integer,
  adsOrders: verifyList.integer,
  cost: verifyList.correctTwo,
  ctr: verifyList.correctTwo,
  adsSales: verifyList.correctTwo,  // 广告销售额 校验不明
  cpc: verifyList.correctTwo,  
  cvr: verifyList.correctTwo,  
  cpa: verifyList.correctTwo,  
  acos: verifyList.correctTwo,  
  roas: verifyList.correctTwo,  
}
export const OpEnum = {
  add: 'add',
};
export const optionMap = {
  campaign: '广告活动',
  autoTarget: '投放组',
  keyword: '关键词',
  manualTarget: '商品投放',
  asinSearch: '搜索词-ASIN',
  keywordSearch: '搜索词-关键词',
  impressions: '曝光量',
  clicks: '点击量',
  cost: '花费',
  ctr: 'CTR',
  cpa: 'CPA',
  adsOrders: '广告订单量',
  adsSales: '广告销售额',
  cpc: 'CPC',
  cvr: 'CVR',
  acos: 'ACOS',
  roas: 'ROAS',
  le: '≤',
  ge: '≥',
  adjustBidoriginal: '原始竞价',
  adjustBudgetoriginal: '原始预算',
  adjustBidrecommendation: '建议竞价',
  adjustBudgetrecommendation: '建议预算',
  adjustBidrecommendationOfMax: '建议竞价最大值',
  adjustBidrecommendationOfMin: '建议竞价最小值',
  targetfixed: '竞价固定',
  adjustBidfixed: '竞价固定',
  adjustBudgetfixed: '预算固定',
  directApply: '直接应用',
  percentageIncrease: '上浮',
  percentageReduction: '下调',
  increase: '上调',
  reduction: '下调',
  targetgroupDefaultBid: '广告组默认竞价',
  targetcpc7d: '过去7天CPC',
  targetcpc14d: '过去14天CPC',
  targetcpc30d: '过去30天CPC',
  negativeTarget: '添加到否定投放',
  parseTarget: '暂停',
};
const keywordSearchAndasinSearch = [
  {
    id: 'negativeTarget',
    text: '添加到否定投放',
  },
  {
    id: 'target',
    text: '添加到投放',
  },
];
const keywordAndKeyword = [
  {
    id: 'adjustBid',
    text: '调整竞价',
  },
  {
    id: 'parseTarget',
    text: '暂停',
  },
  {
    id: 'negativeTarget',
    text: '添加到否定投放',
  },
];
export const option = {
  stateMap: {
    enabled: '已开启',
    paused: '已关闭',
    archived: '已归档',
  },
  notifyTypeOption: [
    {
      id: 'error',
      text: '有错误时通知',
    },
    {
      id: 'complete',
      text: '执行完成时通知',
    },
    {
      id: 'no',
      text: '不通知',
    },
  ],
  executeObjectAdsTypeeOption: {
    // 商品广告
    sp: [
      { id: 'campaign', text: '广告活动' },
      { id: 'keyword', text: '关键词' },
      { id: 'manualTarget', text: '商品投放' },
      { id: 'autoTarget', text: '投放组' },
      { id: 'asinSearch', text: '搜索词-ASIN' },
      { id: 'keywordSearch', text: '搜索词-关键词' },
    ],
    // 品牌广告
    sb: [
      { id: 'campaign', text: '广告活动' },
      { id: 'keyword', text: '关键词' },
      { id: 'manualTarget', text: '商品投放' },
      { id: 'keywordSearch', text: '搜索词-关键词' },
    ],
    // 展示广告
    sd: [
      { id: 'campaign', text: '广告活动' },
      { id: 'manualTarget', text: '商品投放' },
      { id: '', text: '受众' },
    ],
  },

  metricOption: [
    {
      id: 'impressions',
      text: '曝光量',
    },
    {
      id: 'clicks',
      text: '点击量',
    },
    {
      id: 'cost',
      text: '花费',
    },
    {
      id: 'ctr',
      text: 'CTR',
    },
    {
      id: 'adsOrders',
      text: '广告订单量',
    },
    {
      id: 'adsSales',
      text: '广告销售额',
    },
    {
      id: 'cpc',
      text: 'CPC',
    },
    {
      id: 'cvr',
      text: 'CVR',
    },
    {
      id: 'cpa',
      text: 'CPA',
    },
    {
      id: 'acos',
      text: 'ACOS',
    },
    {
      id: 'roas',
      text: 'ROAS',
    },
  ],
  calculateTypeOption: [
    {
      id: 'total',
      text: '总和',
    },
    {
      id: 'avg',
      text: '平均值',
    },
  ],
  expOption: [
    {
      id: 'le',
      text: '≤',
    },
    {
      id: 'ge',
      text: '≥',
    },
  ],
  excludeDayOption: [
    {
      id: 1,
      text: '1',
    },
    {
      id: 3,
      text: '3',
    },
    {
      id: 7,
      text: '7',
    },
  ],
  includeDayOption: [
    {
      id: 7,
      text: '7',
    },
    {
      id: 14,
      text: '14',
    },
    {
      id: 21,
      text: '21',
    },
    {
      id: 30,
      text: '30',
    },
    {
      id: 60,
      text: '60',
    },
    {
      id: 90,
      text: '90',
    },
  ],
  executeIntervalOption: [
    {
      id: 1,
      text: '1',
    },
    {
      id: 7,
      text: '7',
    },
    {
      id: 14,
      text: '14',
    },
    {
      id: 21,
      text: '21',
    },
    {
      id: 30,
      text: '30',
    },
  ],
  // 执行的操作类型
  strategyType: [
    {
      id: 'adjustBudget',
      text: '调整预算',
    },
    {
      id: 'adjustBid',
      text: '调整竞价',
    },
    {
      id: 'target',
      text: '添加投放',
    },
    {
      id: 'negativeTarget',
      text: '添加否定投放',
    },
    {
      id: 'parseTarget',
      text: '暂停',
    },
  ],
  keywordOption: keywordAndKeyword,
  manualTargetOption: keywordAndKeyword,
  asinSearchOption: keywordSearchAndasinSearch,
  keywordSearchOption: keywordSearchAndasinSearch,
  adjustBudgetOption: [
    {
      id: 'original',
      text: '原始预算',
    },
    {
      id: 'recommendation',
      text: '建议预算',
    },
    {
      id: 'fixed',
      text: '固定预算',
    },
  ],
  adjustBidOption: [
    {
      id: 'original',
      text: '原始竞价',
    },
    {
      id: 'recommendation',
      text: '建议竞价',
    },
    {
      id: 'recommendationOfMax',
      text: '建议竞价最大值',
    },
    {
      id: 'recommendationOfMin',
      text: '建议竞价最小值',
    },
    {
      id: 'fixed',
      text: '固定竞价',
    },
  ],
  adjustTypeOption: [
    {
      id: 'directApply',
      text: '直接应用',
    },
    {
      id: 'percentageIncrease',
      text: '上浮百分比',
    },
    {
      id: 'percentageReduction',
      text: '下调百分比',
    },
    {
      id: 'increase',
      text: '上调固定值',
    },
    {
      id: 'reduction',
      text: '下调固定值',
    },
  ],
  targetMatchTypeOption: [
    {
      id: 'exact',
      text: '精确匹配',
    },
    {
      id: 'phrase',
      text: '词组匹配',
    },
    {
      id: 'broad',
      text: '广泛匹配',
    },
  ],
  negativeTargetMatchTypeOption: [
    {
      id: 'exact',
      text: '精确匹配',
    },
    {
      id: 'phrase',
      text: '词组匹配',
    },
  ],
  targetOption: [
    {
      id: 'groupDefaultBid',
      text: '广告组默认竞价',
    },
    {
      id: 'fixed',
      text: '固定竞价',
    },
    {
      id: 'cpc7d',
      text: '过去7天CPC',
    },
    {
      id: 'cpc14d',
      text: '过去14天CPC',
    },
    {
      id: 'cpc30d',
      text: '过去30天CPC',
    },
  ],
};

// 操作类型的条件变化
const inputVerify = {
  // 通用校验
  required: true,
  message: '请输入',
  trigger: 'change',
};
const selectVerify = {
  // 通用校验
  required: true,
  message: '请选择',
  trigger: 'change',
};
// 选项文案 AdjustBase字段值对应
export const writerAdjustBase = () => {
  const data = {
    campaign: {
      original: '原始预算',
      recommendation: '建议预算',
    },
    keyword: {
      original: '原始竞价',
      recommendation: '建议竞价',
      recommendationOfMax: '建议竞价最大值',
      recommendationOfMin: '建议竞价最小值',
    },
    manualTarget: {
      original: '原始竞价',
      recommendation: '建议竞价',
      recommendationOfMax: '建议竞价最大值',
      recommendationOfMin: '建议竞价最小值',
    },
  };
  const getText = (type) =>
    type
      ? `以实际生效时的【${type}】为基准，执行后，系统不会自动回调，建议您设置对应规则`
      : false;
  return { data, getText };
};
const config = {
  // 广告活动
  campaign: [
    // 第一层
    {
      select: {
        belong: 'campaign',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'adjustBudget', text: '调整预算', next: ['select'] },
          { id: 'parseTarget', text: '暂停', next: [] },
        ],
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第二层
    {
      select: {
        belong: 'campaign',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase',
        option: [
          { id: 'original', text: '原始预算', next: ['select'] },
          { id: 'recommendation', text: '建议预算', next: ['select'] },
          { id: 'fixed', text: '固定预算', next: ['input'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第三层
    {
      select: {
        belong: 'campaign',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType',
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          {
            id: 'percentageIncrease',
            text: '上浮百分比',
            next: ['input', 'input2'],
          },
          {
            id: 'percentageReduction',
            text: '下调百分比',
            next: ['input', 'input4'],
          },
          { id: 'increase', text: '上浮绝对值', next: ['input3', 'input2'] },
          { id: 'reduction', text: '下调绝对值', next: ['input3', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'campaign',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
    },
    {
      input: {
        belong: 'campaign',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'campaign',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '预算最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input3: {
        belong: 'campaign',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input4: {
        belong: 'campaign',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '预算最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
  // 关键词
  keyword: [
    // 第一层
    {
      select: {
        belong: 'keyword',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'adjustBid', text: '调整竞价', next: ['select'] },
          { id: 'parseTarget', text: '暂停', next: [] },
          { id: 'negativeTarget', text: '添加否定投放', next: ['select2'] },
        ],
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第二层
    {
      select: {
        belong: 'keyword',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase', // 绑定的字段
        option: [
          { id: 'original', text: '原始竞价', next: ['select'] },
          { id: 'recommendation', text: '建议竞价', next: ['select'] },
          {
            id: 'recommendationOfMax',
            text: '建议竞价最大值',
            next: ['select'],
          },
          {
            id: 'recommendationOfMin',
            text: '建议竞价最小值',
            next: ['select'],
          },
          { id: 'fixed', text: '固定竞价', next: ['input'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      select2: {
        belong: 'keyword',
        element: 'select-ad-aotu', // 组件名
        model: 'matchType', // 绑定的字段
        option: [ // 当前选项
          { id: 'NEGATIVE_EXACT', text: '精准否定', next: [] },
          { id: 'NEGATIVE_PHRASE', text: '词组否定', next: [] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '匹配类型',
        later: '否定到关键词所在的广告组',
      }
    },
    // 第三层
    {
      select: {
        belong: 'keyword',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType', // 绑定的字段
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          {
            id: 'percentageIncrease',
            text: '上浮百分比',
            next: ['input', 'input2'],
          },
          { id: 'increase', text: '上浮绝对值', next: ['input3', 'input2'] },
          {
            id: 'percentageReduction',
            text: '下调百分比',
            next: ['input', 'input4'],
          },
          { id: 'reduction', text: '下调绝对值', next: ['input3', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'keyword',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
    },
    // 第四层
    {
      input: {
        belong: 'keyword',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'keyword',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input3: {
        belong: 'keyword',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input4: {
        belong: 'keyword',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
  // 商品投放
  manualTarget: [
    // 第一层
    {
      select: {
        belong: 'manualTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'adjustBid', text: '调整竞价', next: ['select'] },
          { id: 'parseTarget', text: '暂停', next: [] },
          { id: 'negativeTarget', text: '添加否定投放', next: [] },
        ],
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        laterBind: {key: 'negativeTarget', label: '否定到商品投放所在的广告组'}, // key必须等于同级别的选项才会显示
      },
    },
    // 第二层
    {
      select: {
        belong: 'manualTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase', // 绑定的字段
        option: [
          { id: 'original', text: '原始竞价', next: ['select'] },
          { id: 'recommendation', text: '建议竞价', next: ['select'] },
          {
            id: 'recommendationOfMax',
            text: '建议竞价最大值',
            next: ['select'],
          },
          {
            id: 'recommendationOfMin',
            text: '建议竞价最小值',
            next: ['select'],
          },
          { id: 'fixed', text: '固定竞价', next: ['input'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第三层
    {
      select: {
        belong: 'manualTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType', // 绑定的字段
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          {
            id: 'percentageIncrease',
            text: '上浮百分比',
            next: ['input', 'input2'],
          },
          { id: 'increase', text: '上浮绝对值', next: ['input3', 'input2'] },
          {
            id: 'percentageReduction',
            text: '下调百分比',
            next: ['input', 'input4'],
          },
          { id: 'reduction', text: '下调绝对值', next: ['input3', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'manualTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
    },
    // 第四层
    {
      input: {
        belong: 'manualTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'manualTarget',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input3: {
        belong: 'manualTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input4: {
        belong: 'manualTarget',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
  // 投放组
  autoTarget: [
    // 第一层
    {
      select: {
        belong: 'autoTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'adjustBid', text: '调整竞价', next: ['select'] },
          { id: 'parseTarget', text: '暂停', next: [] },
        ],
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第二层
    {
      select: {
        belong: 'autoTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase', // 绑定的字段
        option: [
          { id: 'original', text: '原始竞价', next: ['select'] },
          { id: 'recommendation', text: '建议竞价', next: ['select'] },
          {
            id: 'recommendationOfMax',
            text: '建议竞价最大值',
            next: ['select'],
          },
          {
            id: 'recommendationOfMin',
            text: '建议竞价最小值',
            next: ['select'],
          },
          { id: 'fixed', text: '固定竞价', next: ['input'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第三层
    {
      select: {
        belong: 'autoTarget',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType', // 绑定的字段
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          {
            id: 'percentageIncrease',
            text: '上浮百分比',
            next: ['input', 'input2'],
          },
          { id: 'increase', text: '上浮绝对值', next: ['input3', 'input2'] },
          {
            id: 'percentageReduction',
            text: '下调百分比',
            next: ['input', 'input4'],
          },
          { id: 'reduction', text: '下调绝对值', next: ['input3', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'autoTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
    },
    // 第四层
    {
      input: {
        belong: 'autoTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'autoTarget',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input3: {
        belong: 'autoTarget',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input4: {
        belong: 'autoTarget',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
  // 搜索词-asin
  asinSearch: [
    // 第一层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'target', text: '添加投放', next: ['select'] },
          { id: 'negativeTarget', text: '添加否定投放', next: [], notOptionFn: true},
        ],
        // 异步处理下一个选项
        nextOptionFn: async (val) => {
          const data = await getAdMarkets();// getAdMarkets
          return data.filter((item) => {
            item.text = `${item.text}：${item.countryCode}`;
            item.next = ['select'];
            return item.status === 'Active';
          });
        },
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        laterBind: {key: 'negativeTarget', label: '否定到搜索词所在的广告组'}, // key必须等于同级别的选项才会显示
      },
    },
    // 第二层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetMarketId', // 绑定的字段
        option: [],
        // 异步处理下一个选项
        nextOptionFn: async (marketId) => {
          const data = await queryCampaigns({
            groupTargetingTypes: [1],
            marketId,
            states: [0],
            targetingType: 0,
          });
          return data.map((item) => {
            item.id = item.campaignId;
            item.text = item.campaignName;
            item.next = ['select'];
            return item;
          });
        },
        saveOption: 'campaignOption',//注意这里方法执行的时候其实是查询的下一步的数据
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '站点',
      },
    },
    // 第三层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetCampaignId', // 绑定的字段
        option: [],
        // 异步处理下一个选项
        nextOptionFn: async (campaignId, item) => {
          const data = await queryGroups({
            campaignIds: [campaignId],
            groupTargetingTypes: [1],
            marketId: item.option.filter(
              (el) => el.campaignId === campaignId
            )[0].marketId,
            states: [0],
            targetingType: 0,
          });
          return data.map((item) => {
            item.id = item.groupId;
            item.text = item.groupName;
            item.next = ['select'];
            return item;
          });
        },
        saveOption: 'groupOption', //注意这里方法执行的时候其实是查询的下一步的数据
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '选择广告活动',
      },
    },
    // 第四层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetGroupId', // 绑定的字段
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '选择广告组',
      },
    },
    // 第五层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase', // 绑定的字段
        option: [
          { id: 'groupDefaultBid', text: '广告组默认竞价', next: [] },
          { id: 'fixed', text: '固定竞价', next: ['input'] },
          { id: 'cpc7d', text: '过去7天CPC', next: ['select'] },
          { id: 'cpc14d', text: '过去14天CPC', next: ['select'] },
          { id: 'cpc30d', text: '过去30天CPC', next: ['select'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第六层
    {
      select: {
        belong: 'asinSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType', // 绑定的字段
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          { id: 'percentageIncrease', text: '上浮百分比', next: ['input', 'input3'] },
          { id: 'increase', text: '上浮绝对值', next: ['input2', 'input3'] },
          { id: 'percentageReduction', text: '下调百分比', next: ['input', 'input4'] },
          { id: 'reduction', text: '下调绝对值', next: ['input2', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'asinSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
        placeholder: '输入竞价',
      },
    },
    // 第七层
    {
      input: {
        belong: 'asinSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'asinSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input3: {
        belong: 'asinSearch',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input4: {
        belong: 'asinSearch',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
  // 搜索词-关键词
  keywordSearch: [
    // 第一层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'strategyType', // 绑定的字段
        option: [
          { id: 'target', text: '添加投放', next: ['select'] },
          { id: 'negativeTarget', text: '添加否定投放', next: ['select2'], notOptionFn: true },
        ],
        // 异步处理下一个选项
        nextOptionFn: async (val) => {
          const data = await getAdMarkets();
          return data.filter((item) => {
            item.text = `${item.text}：${item.countryCode}`;
            item.next = ['select'];
            return item.status === 'Active';
          });
        },
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第二层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetMarketId', // 绑定的字段
        option: [],
        // 异步处理下一个选项
        nextOptionFn: async (marketId) => {
          const data = await queryCampaigns({
            groupTargetingTypes: [0],
            marketId,
            states: [0],
            targetingType: 0,
          });
          return data.map((item) => {
            item.id = item.campaignId;
            item.text = item.campaignName;
            item.next = ['select'];
            return item;
          });
        },
        saveOption: 'campaignOption',//注意这里方法执行的时候其实是查询的下一步的数据
        editDisable: true,
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '站点',
      },
      select2: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'matchType', // 绑定的字段
        option: [ // 当前选项
          { id: 'NEGATIVE_EXACT', text: '精准否定', next: [] },
          { id: 'NEGATIVE_PHRASE', text: '词组否定', next: [] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '匹配类型',
        later: '否定到搜索词所在的广告组',
      }
    },
    // 第三层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetCampaignId', // 绑定的字段
        option: [],
        // 异步处理下一个选项
        nextOptionFn: async (campaignId, item) => {
          const data = await queryGroups({
            campaignIds: [campaignId],
            groupTargetingTypes: [0],
            marketId: item.option.filter(
              (el) => el.campaignId === campaignId
            )[0].marketId,
            states: [0],
            targetingType: 0,
          });
          return data.map((item) => {
            item.id = item.groupId;
            item.text = item.groupName;
            item.next = ['select'];
            return item;
          });
        },
        saveOption: 'groupOption', //注意这里方法执行的时候其实是查询的下一步的数据
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '选择广告活动',
      },
    },
    // 第四层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'targetGroupId', // 绑定的字段
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
        placeholder: '选择广告组',
      },
    },
    // 第五层
    {
      select: {
        belong: 'keywordSearch', // 所属type
        element: 'select-ad-aotu', // 组件名
        model: 'matchType', // 绑定的字段
        option: [ // 当前选项
          { id: 'exact', text: '精确匹配', next: ['select'] },
          { id: 'phrase', text: '词组匹配', next: ['select'] },
          { id: 'broad', text: '广泛匹配', next: ['select'] },
        ],
        clearable: false, //是否可清除
        width: '138px',
        slot: false, //是否启用插槽
        verify: selectVerify, // 校验规则
      },
    },
    // 第六层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustBase', // 绑定的字段
        option: [
          { id: 'groupDefaultBid', text: '广告组默认竞价', next: [] },
          { id: 'fixed', text: '固定竞价', next: ['input'] },
          { id: 'cpc7d', text: '过去7天CPC', next: ['select'] },
          { id: 'cpc14d', text: '过去14天CPC', next: ['select'] },
          { id: 'cpc30d', text: '过去30天CPC', next: ['select'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
    },
    // 第七层
    {
      select: {
        belong: 'keywordSearch',
        element: 'select-ad-aotu', // 组件名
        model: 'adjustType', // 绑定的字段
        option: [
          { id: 'directApply', text: '直接应用', next: [] },
          { id: 'percentageIncrease', text: '上浮百分比', next: ['input', 'input3'] },
          { id: 'increase', text: '上浮绝对值', next: ['input2', 'input3'] },
          { id: 'percentageReduction', text: '下调百分比', next: ['input', 'input4'] },
          { id: 'reduction', text: '下调绝对值', next: ['input2', 'input4'] },
        ],
        clearable: false,
        width: '138px',
        slot: false,
        verify: selectVerify,
      },
      input: {
        belong: 'keywordSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
        placeholder: '输入竞价',
      },
    },
    // 第八层
    {
      input: {
        belong: 'keywordSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: true,
        verify: verifyList.correctTwo,
      },
      input2: {
        belong: 'keywordSearch',
        element: 'gj-input', // 组件名
        model: 'adjustValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        verify: verifyList.correctTwo,
      },
      input3: {
        belong: 'keywordSearch',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最大值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
      input4: {
        belong: 'keywordSearch',
        element: 'gj-input', // 组件名
        model: 'adjustLimitValue',
        option: [],
        clearable: false,
        width: '138px',
        slot: false,
        label: '竞价最小值',
        verify: verifyList.correctTwo,
        class: 'error-padding',
      },
    },
  ],
};
export const selectMap = () => {
  const orderMap = {
    first: 'second',
    second: 'third',
  };
  const getNext = (option, id) => {
    return option.filter((item) => item.id === id)[0].next;
  };
  // 获取下一层 层级数据
  const getData = (item, index, next) => {
    if (!next) {
      // 没有下一层
      return false;
    }
    const data = config[item.belong][index + 1][next];
    return data;
  };
  return { getNext, getData, orderMap, config };
};

export const ruleMap = {
  executeObjectAdsType: option.executeObjectAdsTypeeOption.sp,
  expressionList: {
    metric: option.metricOption, //指标
    calculateType: option.calculateTypeOption, //计算类型
    exp: option.expOption, //符号
  },
};

// 广告规则转化
export const ruleText = {
  original: '原始预算',
  recommendation: '建议预算',
  fixed: '固定预算调整为',
  groupDefaultBid: '调整为广告组默认竞价',
  cpc7d: '调整为过去7天CPC',
  cpc14d: '调整为过去14天CPC',
  cpc30d: '调整为过去30天CPC',
  percentageIncrease: '上浮',
  percentageReduction: '下调',
  increase: '上浮',
  reduction: '下调',
  directApply: '直接应用',
  recommendationOfMax: '建议价格最大值',
  recommendationOfMin: '建议价格最小值',
  exact: '精确匹配',
  phrase: '词组匹配',
  broad: '广泛匹配',
};

// 用于基础信息中的元素排序
export const baseInfoOrder = {
  rule: {
    object: {order: 2}, //  应用对象
    // type: {order: 2}, //  广告类型
    template: {order: 1}, //  内容模板
    inform: {order: 5}, //  结果通知
    name: {order: 4} //  规则名称
  },
  template: {
    name: {order: 1},
    inform: {order: 2},
    type: {order: 3},
  }
}

export const objectAdsType = {
  campaign: '广告活动',
  group: '广告组',
  placement: '广告位',
  keyword: '关键词',
  manualTarget: '商品投放',
  autoTarget: '投放组',
  asinSearch: '搜索词-ASIN',
  keywordSearch: '搜索词-关键词',
}

export const guideData = [
  {
      id: 1,
      title: "填写基本信息", // 标题
      text: '', // 文本
      list: [],
      preBtn: '', //上一步按钮
      nextBtn: "下一步", // 下一步按钮
      closeBtn: '', // 完成按钮
      shadowCoord: {top: '120px', left: '16px', width: 'calc(100% - 32px)', height: '144px'}, // 阴影坐标
      textCoord: {top: '284px', left: '300px', width: '330px'} // 内容坐标
  },
  {
      id: 2,
      title: "选择需要调整的对象", // 标题
      text: '', // 文本
      list: [],
      preBtn: '上一步', //上一步按钮
      nextBtn: "下一步", // 下一步按钮
      closeBtn: '', // 完成按钮
      nextFn: (_this) => {
        return new Promise((res, rej) => {
          const el = document.querySelector('.guide-rule-main');
          el.scrollTop = el.scrollHeight
          console.log(_this);// 171
          _this.guideData_[2].shadowCoord.top = `${400 - el.scrollTop}px`;
          _this.guideData_[2].textCoord.top = `${287 - el.scrollTop}px`;

          _this.guideData_[3].shadowCoord.top = `${579 - el.scrollTop}px`;
          _this.guideData_[3].textCoord.top = `${465 - el.scrollTop}px`;
          res();
        })
      },
      shadowCoord: {top: '345px', left: '16px', width: '293px', height: '66px'}, // 阴影坐标
      textCoord: {top: '345px', left: '326px', width: '330px'} // 内容坐标
  },
  {
      id: 3,
      title: "填写执行需要满足的条件", // 标题
      text: '', // 文本
      list: [],
      preBtn: '上一步', //上一步按钮
      nextBtn: "下一步", // 下一步按钮
      closeBtn: '', // 完成按钮
      shadowCoord: {top: '400px', left: '16px', width: '1029px', height: '194px'}, // 阴影坐标
      textCoord: {top: '287px', left: '715px', width: '330px'} // 内容坐标
  },
  {
      id: 4,
      title: "填写执行的操作", // 标题
      text: '', // 文本
      list: [],
      preBtn: '上一步', //上一步按钮
      nextBtn: "", // 下一步按钮
      closeBtn: '知道了', // 完成按钮
      shadowCoord: {top: '579px', left: '16px', width: '440px', height: '112px'}, // 阴影坐标
      textCoord: {top: '465px', left: '127px', width: '330px'}, // 内容坐标
      closeParams: {
        name: 'adAutoRuleCreate',
        description: '广告自动化模板创建提示展示'
    },
  },
]

